import { Global } from '@emotion/react';

import createGlobalStyles from './GlobalStylesService';

function GlobalStyles() {
  return <Global styles={createGlobalStyles} />;
}

export default GlobalStyles;
